<form [formGroup]="followupCompleteForm" novalidate class="followup-complete-form" (ngSubmit)="archivePatient(patient)">
  <ng-container *ngIf="patient">
    <div class="followup-complete-shell">
      <div
        class="graduation-container modal-drag-handle"
        appDraggableModal
        role="button"
        tabindex="0"
        aria-label="Move follow-up completion dialog"
        title="Drag to move dialog"
      >
        <span class="modal-drag-grip" aria-hidden="true"></span>
        <ion-title>Follow-up</ion-title>
        <img class="graduation-image" src="/assets/complete-graphic@2x.png" alt="" />
      </div>

      <div class="modal-body">
        <div class="patient-status-container">
          <ng-container *ngIf="completionTypesLoading && !completionTypes.length; else completionOptionsState">
            <div class="completion-loading">
              <ion-spinner name="crescent"></ion-spinner>
              <span>Loading completion options...</span>
            </div>
          </ng-container>

          <ng-template #completionOptionsState>
            <div *ngIf="completionTypesError; else completionOptions" class="completion-load-error" role="alert">
              <span>{{ completionTypesError }}</span>
              <button class="secondary button completion-retry-button" type="button" (click)="loadCompletionTypes()">
                Retry
              </button>
            </div>
          </ng-template>

          <ng-template #completionOptions>
            <div
              class="graduation-options-container"
              role="group"
              aria-label="Completion status"
            >
              <ion-item *ngFor="let patientStatus of completionTypes" class="status-option" lines="none">
                <ion-checkbox
                  class="status-checkbox followup-form-choice followup-form-choice--compact"
                  [checked]="isCompletionTypeSelected(patientStatus.patientStatusLabelId)"
                  (ionChange)="onCompletionTypeChange(patientStatus.patientStatusLabelId, $event.detail.checked)"
                  labelPlacement="end"
                  alignment="center"
                  justify="start"
                >
                  {{ patientStatus.patientStatusLabel }}
                </ion-checkbox>
              </ion-item>
            </div>
          </ng-template>
        </div>

        <ion-textarea
          class="completion-notes"
          [autoGrow]="true"
          formControlName="completionNotes"
          placeholder="Any Notes?"
          spellcheck="true"
          autocorrect="on"
          autocapitalize="sentences"
        ></ion-textarea>
      </div>

      <div class="send-container">
        <p class="completion-error" *ngIf="completionSaveError" role="alert">{{ completionSaveError }}</p>
        <button class="secondary button" type="button" (click)="dismiss()">Cancel</button>
        <button
          class="primary button"
          type="submit"
          [disabled]="isSaving || followupCompleteForm.invalid || completionTypesLoading || !!completionTypesError"
        >
          Save
        </button>
      </div>
    </div>
  </ng-container>
</form>
